import { AxiosResponse } from 'axios';
import api from './api';

const getEvent = async (payload: Services.Events.GetEvent): Promise<AxiosResponse> => (
  api.get('event', { params: { ...payload } })
);

const getEvents = async (payload: Services.Events.GetEvents): Promise<AxiosResponse> => (
  api.get('events', { params: { ...payload } })
);

const postEvent = async (payload: Services.Events.PostEvent): Promise<AxiosResponse> => (
  api.post('event', payload)
);

const putEvent = async (payload: Services.Events.PutEvent): Promise<AxiosResponse> => (
  api.put('event', { ...payload })
);

const deleteEvent = async (eventIds: number[]): Promise<AxiosResponse> => (
  api.delete('events', { data: { eventIds } })
);

const startOrEndLive = async (payload: Services.Events.StartOrEndLive): Promise<AxiosResponse> => (
  api.put('event/start-or-end-live', { ...payload })
);

const downloadEvent = async (payload: Services.Events.DownloadEvent): Promise<AxiosResponse> => (
  api.get('event/download', { params: { ...payload } })
);

const events = {
  getEvent,
  getEvents,
  postEvent,
  putEvent,
  deleteEvent,
  startOrEndLive,
  downloadEvent,
};

export default events;
